import React, { Fragment } from "react";
import { Helmet } from "react-helmet";
import Header from "../../components/Header/Header";
import PageTitle from "../../components/pagetitle/PageTitle";
import Scrollbar from "../../components/scrollbar/scrollbar";
import Footer from "../../components/footer/Footer";
import ContactInfoSection from "./ContactInfoSection";
import ContactForm from "../../components/ContactFrom/ContactForm";

// import background image
import contactBg from "../../images/bg/contact-bg02.png";

const ContactPage: React.FC = () => {
  return (
    <Fragment>
      <Helmet>
        <title>Contact Us | AquarLabs - Get in Touch</title>
        <meta name="description" content="Contact AquarLabs for AI solutions, cloud services, and digital transformation. Reach us via email at info@aquarlabs.com or phone. Based in Visakhapatnam, India." />
        <meta name="keywords" content="contact AquarLabs, AI solutions India, tech company contact, get in touch, Visakhapatnam" />
        <link rel="canonical" href="https://aquarlabs.com/contact-us" />
        <meta property="og:title" content="Contact Us | AquarLabs" />
        <meta property="og:description" content="Get in touch with AquarLabs for AI solutions and digital transformation services." />
        <meta property="og:url" content="https://aquarlabs.com/contact-us" />
        <meta name="twitter:title" content="Contact Us | AquarLabs" />
        <meta name="twitter:description" content="Get in touch with AquarLabs for AI solutions and digital transformation services." />
      </Helmet>
      <div className='about-page inner-page'>
        <div className="body_wrap o-clip">
          <Header />
          <main>
            <PageTitle pageTitle="Contact us" pagesub="Contact us" />
            {/* <ContactInfoSection /> */}
            <section className="contact">
              <div className="container">
                <div
                  className="xb-contact-wrap xb-border bg_img"
                  style={{
                    backgroundImage: `url(${contactBg})`,
                  }}
                >
                  <div className="xb-contact-form xb-main-contact xb-border">
                    <div className="form-heading text-center mb-30">
                      <h3 className="title">Ready to collaborate with us?</h3>
                      <p className="sub-title clr-white">
                        Who knows where a single message might lead you.
                      </p>
                    </div>

                    <ContactForm />
                  </div>

                  {/* Contact Information Section */}
                  <div className="contact-info-section">
                    <div className="contact-info-content">
                      <h3 className="contact-info-title">Get in Touch</h3>
                      <p className="contact-info-subtitle">We'd love to hear from you. Here's how you can reach us.</p>

                      <div className="contact-info-grid">
                        {/* Email */}
                        <div className="contact-info-item">
                          <div className="contact-info-icon">
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M4 4H20C21.1 4 22 4.9 22 6V18C22 19.1 21.1 20 20 20H4C2.9 20 2 19.1 2 18V6C2 4.9 2.9 4 4 4Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                              <path d="M22 6L12 13L2 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                          </div>
                          <div className="contact-info-details">
                            <h4>Email</h4>
                            <a href="mailto:info@aquarlabs.com">info@aquarlabs.com</a>
                          </div>
                        </div>

                        {/* Phone */}
                        <div className="contact-info-item">
                          <div className="contact-info-icon">
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M22 16.92V19.92C22 20.49 21.54 20.95 20.97 20.92C10.05 20.24 3.03 13.2 2.08 2.93C2.04 2.36 2.49 1.89 3.06 1.89H6.09C6.6 1.89 7.02 2.27 7.07 2.78C7.18 3.77 7.4 4.71 7.72 5.6C7.85 5.97 7.74 6.38 7.47 6.65L5.9 8.22C7.07 10.86 9.62 13.41 12.26 14.58L13.83 13.01C14.1 12.74 14.51 12.63 14.88 12.76C15.77 13.08 16.71 13.3 17.7 13.41C18.21 13.46 18.59 13.88 18.59 14.39V17.42C18.92 17.42 22 17.49 22 16.92Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                          </div>
                          <div className="contact-info-details">
                            <h4>Phone</h4>
                            <a href="tel:+918367036704">+(91) 8 3670 3670 4</a>
                          </div>
                        </div>

                        {/* Location */}
                        <div className="contact-info-item">
                          <div className="contact-info-icon">
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M21 10C21 17 12 23 12 23C12 23 3 17 3 10C3 7.61305 3.94821 5.32387 5.63604 3.63604C7.32387 1.94821 9.61305 1 12 1C14.3869 1 16.6761 1.94821 18.364 3.63604C20.0518 5.32387 21 7.61305 21 10Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                              <path d="M12 13C13.6569 13 15 11.6569 15 10C15 8.34315 13.6569 7 12 7C10.3431 7 9 8.34315 9 10C9 11.6569 10.3431 13 12 13Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                          </div>
                          <div className="contact-info-details">
                            <h4>Location</h4>
                            <p>Visakhapatnam, India</p>
                          </div>
                        </div>

                        {/* Business Hours */}
                        <div className="contact-info-item">
                          <div className="contact-info-icon">
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                              <path d="M12 6V12L16 14" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                          </div>
                          <div className="contact-info-details">
                            <h4>Business Hours</h4>
                            <p>Mon - Fri: 9:00 AM - 6:00 PM IST</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </main>
          <Footer />
          <Scrollbar />
        </div>
      </div>
    </Fragment>
  );
};

export default ContactPage;